import { render, staticRenderFns } from "./AttachTemplate.vue?vue&type=template&id=45f03130&scoped=true&"
import script from "./AttachTemplate.vue?vue&type=script&lang=js&"
export * from "./AttachTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AttachTemplate.vue?vue&type=style&index=0&id=45f03130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f03130",
  null
  
)

export default component.exports